import { mapGetters, mapState } from 'vuex';
import { roles } from './staticData';

export default {
  data() {
    return {
      userRoles: roles,
    };
  },
  computed: {
    userRole() {
      return Number(this.$store.state.AuthStore.userData.role.id);
    },
    ...mapGetters('AuthStore', {
      permission: 'verifyPerms',
    }),
    ...mapState('AuthStore', ['userData']),
  },
};
